// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 2H10V10H14V5H22V22H13V15H11V22H2V2ZM4 20H6V10H8V4H4V20ZM16 10H18V20H20V7H16V10Z"}}]};

const City12FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-12-filled',
    ref,
    icon: element,
  },
));

City12FilledIcon.displayName = 'City12FilledIcon';

export default City12FilledIcon;
